import { CardContent } from "@mui/material";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Card, Modal } from "react-bootstrap";
import OwlCarousel from "react-owl-carousel";
import singleFrame from "../../Assets/Images/Normal-User/Single-frame.png";
import bKashLogo from "../../Assets/Images/Payment-img/BKash-bKash-Logo.wine.png";
import payoneerLogo from "../../Assets/Images/Payment-img/Payoneer-Logo.wine.png";
import paytm from "../../Assets/Images/Payment-img/Paytm_Logo.png";
import strip from "../../Assets/Images/Payment-img/strip.png";
import shujoPay from "../../Assets/Images/Payment-img/shurjo-pay.jpeg";
// import ipay88 from "../../Assets/Images/Payment-img/ipay88.svg";

// import "../../../CSS/Packages/BuyPackages.css";
// import "./PaymentModal.css";
import swal from "sweetalert";
import { usePaytm } from "../../CustomHooks/usePaytm";
import { useStripePayment } from "../../CustomHooks/useStripePayment";
import StripeModal from "../Modal/PaymentModal/StripeModal";
import { useShurjoPay } from "../../CustomHooks/useShurjoPay";
import { LocationContext } from "../../CustomHelper/Helper";
import { useSSLCommerzPay } from "../../CustomHooks/useSSLCommerzPay";
import { useHistory } from "react-router-dom";

const WalletPlanPayModal = (props) => {
  const [walletInfo, setWalletInfo] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [regBuffer, setRegBuffer] = useState(false);

  const user_id = localStorage.getItem("auth_id");
  const history = useHistory();

  const {
    paymentCount,
    paymentCountWithSymbolCountry,
    paymentCountWithSymbol,
    payStatus,
    slectedCurrency,
  } = useContext(LocationContext);

  const { makePaytmPayment, paymentBuffer } = usePaytm({
    event_id: props?.modalPara[0], //audition uploads video id
    amount: props?.modalPara[1], //paymentCount(props?.modalPara[2])
    redirectTo: "loyalty_wallet/plan",
    type: "wallet_plan",
  });

  const {
    stripeMakePayment,
    stripeBuffer,
    clientSecret,
    publicKey,
    error,
    stripeModalShow,
    setStripeModalShow,
  } = useStripePayment({
    amount: paymentCountWithSymbolCountry(props?.modalPara[2]), //props?.modalPara[2]
    event_type: "plan",
    event_id: props?.modalPara[0],
  });

  const { shurjoPayMakePayment, shurjoBuffer } = useShurjoPay({
    amount: paymentCount(props?.modalPara[2]), //paymentCount(props?.modalPara[3])
    event_type: "plan",
    event_id: props?.modalPara[0],
    client_ip: "web",
  });
  console.log("props?.modalPara", props?.modalPara);
  const { sslCommerzBuffer, sslCommerzPayMakePayment } = useSSLCommerzPay({
    amount: paymentCount(props?.modalPara[2]),
    event_type: "plan",
    event_id: props?.modalPara[0],
    client_ip: "web",
  });

  // const { sslCommerzBuffer,sslCommerzPayMakePayment } = useSSLCommerzPay({
  //   amount: props?.fee,
  //   event_type: props?.event_type,
  //   event_id: props?.event_id
  // });

  const handleReact = (type) => {
    // let data = {
    //   videoId: props.modalPara[0],
    //   reactNum: props.modalPara[1],
    //   fee: props.modalPara[2],
    //   type: type,
    // };
    // axios
    //   .post("api/user/audition/videos/loveReact/payment", data)
    //   .then((res) => {
    //     if (res.data.status === 200) {
    //       props.setLiked(1);
    //       props.onHide();
    //       getWalletInfo();
    //     }
    //   });
  };

  const getWalletInfo = () => {
    axios.get("api/user/wallet/details").then((res) => {
      if (res.data.status === 200) {
        setWalletInfo(res.data.userWallet);
      }
    });
  };

  /**
   * ipay88 make payment
   */
  const ipay88MakePayment = () => {
    window.location.replace(
      `https://backend.hellosuperstars.com/ipay88-make-payment/${user_id}/${props?.modalPara[2]}/loveReact/${props?.modalPara[0]}/${props?.modalPara[1]}/web`
    );
  };

  useEffect(() => {
    getWalletInfo();
  }, []);

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body>
        <Card style={{ backgroundColor: "#25272b" }} sx={{ minWidth: 275 }}>
          <div
            onClick={props.onHide}
            className="d-flex justify-content-end p-2"
          >
            <div className="closeNotificationDrop text-center">X</div>
          </div>
          <br />

          <div className="text-warning text-bold text-center">
            Pay: {paymentCountWithSymbol(props?.modalPara[2])}{" "}
            {/* {paymentCountWithSymbol(props?.modalPara[2]) } */}
          </div>

          <CardContent>
            <div className="text-center image-middle">
              <img className="singleFrame-style" src={singleFrame} alt="" />
              <h3 className="centered">Payment Method</h3>
            </div>

            <div>
              <div
                className="owl-theme"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                  justifyContent: "space-around",
                  alignItems: "",
                }}
              >
                <div
                  className="item"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    makePaytmPayment();
                  }}
                >
                  <img src={paytm} alt="" className="img-fluid payment-img" />
                </div>
                <div className="item" onClick={() => stripeMakePayment()}>
                  <img src={strip} alt="" className="img-fluid payment-img" />
                </div>
                <div
                  className="item"
                  onClick={() => {
                    sslCommerzPayMakePayment();
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src={shujoPay}
                    alt=""
                    className="img-fluid payment-img"
                  />
                </div>

                {/* <div
                  className="item my-5"
                  onClick={() => ipay88MakePayment()}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src={ipay88}
                    alt=""
                    className="img-fluid payment-img"
                  />
                </div> */}
              </div>
            </div>

            <div>
              <div>
                {/* <button  onClick={formSubmit}  className="my-3 btn btn-gold">Confirm Payment</button> */}
                <div className="row my-2">
                  <div className="col-md-4 mx-auto">
                    <button className="btn btn-info btnTest rounded-3 w-100 fw-bold">
                      Avaiable :
                      {walletInfo?.love_points ? walletInfo?.love_points : "00"}
                    </button>
                  </div>
                  <div className="col-md-4 mx-auto">
                    {walletInfo?.love_points ? (
                      <button
                        className="btn btn-info btnTest rounded-3 w-100 fw-bold"
                        onClick={() => handleReact("wallet")}
                      >
                        Use wallet
                      </button>
                    ) : (
                      <button
                        className="btn btn-info btnTest rounded-3 w-100 fw-bold"
                        disabled
                      >
                        Use wallet
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </Modal.Body>
      <StripeModal
        show={stripeModalShow}
        onHide={() => setStripeModalShow(false)}
        amount={props?.modalPara[2]}
        event_id={props?.modalPara[0]}
        event_type="plan"
        clientSecret={clientSecret}
        publicKey={publicKey}
      />
    </Modal>
  );
};

export default WalletPlanPayModal;
